export default function($) {

  window.Iw_product_variation = function(product_variation){
    this.product_variation = product_variation
    this.quantity_input = this.product_variation.find('.js-variation_quantity_selector')

    // Hooks maybe injected function
    this.before_add_to_cart = this.product_variation.data('before-add-to-cart');
    this.after_add_to_cart = this.product_variation.data('after-add-to-cart');

    // Variation data
    this.product_id = this.quantity_input.data("product-id")
    this.variation_id = this.quantity_input.data("variation-id")
    this.attributes = this.quantity_input.data("attributes")
  }

  Iw_product_variation.prototype = {
    validate: function() {
      // Before add to cart client hook if provided (Client custom validation)
      var fn = window[this.before_add_to_cart];
      if (typeof fn === 'function') {
        var before_add_to_cart_result = fn(this);
        if (before_add_to_cart_result !== true) {
          // if not return true display the error and prevent the ajax call
          var validation_error = before_add_to_cart_result;
          this.render("validation_error", validation_error);
          return false;
        }
      }

      this.render("remove_maybe_validation_error");
      if (this.quantity() <= 0) {
        // No need for an ajax call because the quantity requested is null
        return false;
      }

      return true;
    },
    add_to_cart: function() {
      var self = this
      $.ajax({
        url: client_configuration.ajax_url,
        data: {
          "action" : "woocommerce_add_variations_to_cart",
          "variations" : [{
            "product_id" : this.product_id,
            "variation_id" : this.variation_id,
            "quantity" : this.quantity(),
            "attributes" : this.attributes,
          }],
        },
        type: "POST",
        success: function() {
          // We force refresh woocommerce mini-cart fragments using
          // WooCommerce native event 'wc_fragment_refresh'
          $( document.body ).trigger( 'wc_fragment_refresh' );

          self.do_after_add_to_cart_action()
          self.render("success")
        }
      })
    },
    do_after_add_to_cart_action: function() {
      // After add to cart client hook if provided
      var fn = window[this.after_add_to_cart];
      if (typeof fn === 'function') {
        var after_add_to_cart_result = fn(this);
      }
    },
    quantity: function() {
      return this.quantity_input.val()
    },
    render: function(action, data="") {
      switch(action) {
        case "validation_error":
          $("#validation_error_"+this.variation_id).remove();
          this.product_variation.before(data);
          break;
        case "remove_maybe_validation_error":
          $("#validation_error_"+this.variation_id).remove();
          break;
        case "success":
          this.quantity_input.removeClass('iw-qty-updated').val(0).addClass('iw-qty-updated');
          break;
      }
    }
  }

  $(document).ready(function () {
    var add_variation_to_cart_buttons = $('.js-iw-product-variation-add-to-cart');

    // we do nothing if the selector is not found
    if (add_variation_to_cart_buttons.length) {
      add_variation_to_cart_buttons.each(function () {
        $(this).click(function(event) {
          event.preventDefault()
          var product_variation = new Iw_product_variation(
            $(this).closest('.js-iw-product-variation')
          )

          if ( product_variation.validate() ) {
            product_variation.add_to_cart()
          }
        })
      })
    }

  })

}
